export default __webpack_public_path__ + "static/media/starNotChecked.6dfabe27.svg";